/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import moment from 'moment';

export const REQUESTED_EXTERNAL_INVESTMENT_BALANCES =
  'REQUESTED_EXTERNAL_INVESTMENT_BALANCES';
export const requestedExternalInvestmentBalances = () => ({
  type: REQUESTED_EXTERNAL_INVESTMENT_BALANCES,
  time: moment().tz('America/New_York').format('MM/DD/YYYY h:mma')
});

export const RECEIVED_EXTERNAL_INVESTMENT_BALANCES =
  'RECEIVED_EXTERNAL_INVESTMENT_BALANCES';
export const receivedExternalInvestmentBalances = (investments) => ({
  type: RECEIVED_EXTERNAL_INVESTMENT_BALANCES,
  investments
});

export const ERROR_EXTERNAL_INVESTMENT_BALANCES =
  'ERROR_EXTERNAL_INVESTMENT_BALANCES';
export const errorExternalInvestmentBalances = (error) => ({
  type: ERROR_EXTERNAL_INVESTMENT_BALANCES,
  error
});

export const REQUESTED_REFRESH_EXTERNAL_INVESTMENT_BALANCES =
  'REQUESTED_REFRESH_EXTERNAL_INVESTMENT_BALANCES';
export const requestedRefreshExternalInvestmentBalances = () => ({
  type: REQUESTED_REFRESH_EXTERNAL_INVESTMENT_BALANCES,
  time: moment().tz('America/New_York').format('MM/DD/YYYY h:mma')
});

export const RECEIVED_REFRESH_EXTERNAL_INVESTMENT_BALANCES =
  'RECEIVED_REFRESH_EXTERNAL_INVESTMENT_BALANCES';
export const receivedRefreshExternalInvestmentBalances = (investments) => ({
  type: RECEIVED_REFRESH_EXTERNAL_INVESTMENT_BALANCES,
  investments
});

export const ERROR_REFRESH_EXTERNAL_INVESTMENT_BALANCES =
  'ERROR_REFRESH_EXTERNAL_INVESTMENT_BALANCES';
export const errorRefreshExternalInvestmentBalances = (error) => ({
  type: ERROR_REFRESH_EXTERNAL_INVESTMENT_BALANCES,
  error
});
